// api/axiosInstance.ts
import { isTokenExpired } from '@/utils/auth';
import { fileService } from '@/utils/filesService';
import { Database } from '@/utils/persistence';
import axios from 'axios';
export interface Response<T> {
  ok: boolean;
  message: string;
  data: T;
}

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // 从环境变量中读取 API 基础 URL
  timeout: 120000, // 请求超时时间
  withCredentials: true
});

export const clearCookies = () => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [name] = cookie.split("=");
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
};

export const handleLogout = async () => {
  try {
    await Database.destroyDatabase();
  }
  catch (e) {
    console.error("Error during logout:", e);
  } finally {
    const hasConsent = localStorage.getItem('cookieConsent');
    const rememberedAccount = localStorage.getItem('rememberedAccount');
    localStorage.clear();
    fileService.destroy();
    clearCookies();

    if (hasConsent === 'true') {
      localStorage.setItem('cookieConsent', 'true');
    }

    if (rememberedAccount) {
      localStorage.setItem('rememberedAccount', rememberedAccount);
    }

    // 设置标记表示这是用户退出登录的刷新，不需要确认提示
    sessionStorage.setItem("skipBeforeUnload", "true");
    window.location.reload();
  }
};

// 请求拦截器
axiosInstance.interceptors.request.use(
  async config => {
    // 检查是否需要跳过 token
    if (config.headers && config.headers['Skip-Auth']) {
      delete config.headers['Skip-Auth'];
      return config;
    }
    let token = localStorage.getItem('token');
    if (token) {
      if (isTokenExpired(token)) {
        // // Token expired, refresh it
        // const originalRequest = config;
        // try {
        //   const res = await refreshToken();
        //   if (res) {
        //     token = res.token;
        //   }
        //   localStorage.setItem('token', token);
        //   originalRequest.headers.Authorization = `Bearer ${token}`;
        //   return axiosInstance(originalRequest);
        // } catch (error) {
        //   console.error('Failed to refresh token', error);
        handleLogout();
        window.location.href = (import.meta.env.VITE_ROUTE_BASE ?? "") + '/login';
        // return Promise.reject(error);
        // }
      } else {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } else {
      window.location.href = (import.meta.env.VITE_ROUTE_BASE ?? "") + '/login';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
// axiosInstance.interceptors.response.use(
//   response => {
//     // 对响应数据做些什么
//     return response.data;
//   },
//   error => {
//     // 对响应错误做些什么
//     // message.error(error.code);
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;